<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: space-between;">
            <el-input v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(true)"/>
          </div>
          <div style="display: flex;justify-content: flex-end;">
            <el-button type="primary" size="small" @click="openDialog(null, false)"
                       icon="el-icon-plus">新增
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="小区" align="center"
                             prop="communityName"></el-table-column>
            <el-table-column show-overflow-tooltip label="房源" align="center"
                             prop="houseName"></el-table-column>
            <el-table-column show-overflow-tooltip label="房间" align="center"
                             prop="roomName"></el-table-column>
            <el-table-column show-overflow-tooltip label="签约类型" align="center" prop="oldRentRecordId">
              <template slot-scope="scope">
                <span v-if="scope.row.oldRentRecordId">续签</span>
                <span v-else>新签</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="管理员" align="center"
                             prop="adminName"></el-table-column>
            <el-table-column show-overflow-tooltip label="付款方式" align="center"
                             prop="payType">
              <template slot-scope="scope">
                <span v-if="scope.row.payType == 0">月付</span>
                <span v-if="scope.row.payType == 4">两月付</span>
                <span v-if="scope.row.payType == 1">季付</span>
                <span v-if="scope.row.payType == 2">半年付</span>
                <span v-if="scope.row.payType == 3">年付</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="状态" align="center"
                             prop="state">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 0">出租中</span>
                <span v-if="scope.row.state == 1">正退</span>
                <span v-if="scope.row.state == 2">违退</span>
                <span v-if="scope.row.state == 3">已结束</span>
                <span v-if="scope.row.state == 4">未生效</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="押金" align="center"
                             prop="deposit"></el-table-column>
            <el-table-column show-overflow-tooltip label="支出中介费" align="center"
                             prop="agencyFee"></el-table-column>
            <el-table-column show-overflow-tooltip label="租金" align="center"
                             prop="rent"></el-table-column>
            <el-table-column show-overflow-tooltip label="开始日期" align="center"
                             prop="startDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="结束日期" align="center"
                             prop="endDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="首次收租日期" align="center"
                             prop="firstRentDate" width="120"></el-table-column>
<!--            <el-table-column show-overflow-tooltip label="合同日期" align="center"-->
<!--                             prop="contractDate"></el-table-column>-->
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="360" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="toDetail(scope.row)" v-if="showButton">明细</el-button>
                <el-button type="text" @click="openBreakDialog(scope.row, 1)" v-if="scope.row.state == 0 && showButton">正退</el-button>
                <el-button type="text" @click="openBreakDialog(scope.row, 2)" v-if="scope.row.state == 0 && showButton">违退</el-button>
                <el-button type="text" @click="openContractDialog(scope.row)">合同</el-button>
                <el-button type="text" @click="openImage(scope.row.id)" v-if="showButton">合同二维码</el-button>
<!--                <el-button type="text" @click="openDialog(scope.row, true)" v-if="!scope.row.rentContract || !scope.row.rentContract.partyBSignName">编辑</el-button>-->
                <el-button type="text" style="color: #ff4949;" @click="deleteData(scope.row.id)" v-if="showButton">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="rentRecordDialog.visible" :close-on-click-modal="false" width="40%"
               :title="!isEdit ? '新增出租记录' : '编辑出租记录'">
      <el-form ref="rentRecordForm" label-position="right" label-width="120px" :model="rentRecordDialog.formData"
               :rules="rules" style="height: 500px;overflow-y: auto;padding: 0 20px;">
        <el-form-item label="房间：" prop="roomId">
          <el-select filterable v-model="rentRecordDialog.formData.roomId" placeholder="请选择房间" clearable disabled
                     style="width: 100%;">
            <el-option v-for="item in rooms" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理员：" prop="adminId">
          <el-select filterable  v-model="rentRecordDialog.formData.adminId" placeholder="请选择管理员" clearable style="width: 100%;">
            <el-option v-for="item in admins" :key="item.id" :value="item.id"
                       :label="item.nickname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款方式：" prop="payType">
          <el-select filterable v-model="rentRecordDialog.formData.payType" placeholder="请选择付款方式" clearable
                     style="width: 100%;">
            <el-option v-for="item in payTypes" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="状态：" prop="state">-->
<!--          <el-select filterable v-model="rentRecordDialog.formData.state" placeholder="请选择状态" clearable-->
<!--                     style="width: 100%;" @change="changePayType" disabled>-->
<!--            <el-option v-for="item in states" :key="item.id" :value="item.id"-->
<!--                       :label="item.name"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="租金：" prop="rent">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%"
                           v-model="rentRecordDialog.formData.rent"
                           clearable/>
        </el-form-item>
        <el-form-item label="押金：" prop="deposit">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%"
                           v-model="rentRecordDialog.formData.deposit"
                           clearable/>
        </el-form-item>
        <el-form-item label="支出中介费：" prop="agencyFee">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%"
                           v-model="rentRecordDialog.formData.agencyFee"
                           clearable/>
        </el-form-item>
        <el-form-item label="开始日期：" prop="startDate">
          <el-date-picker
            v-model="rentRecordDialog.formData.startDate"
            type="date"
            placeholder="请选择开始日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期：" prop="endDate">
          <el-date-picker
            v-model="rentRecordDialog.formData.endDate"
            type="date"
            placeholder="请选择结束日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="首次收租日期：" prop="firstRentDate">
          <el-date-picker
            v-model="rentRecordDialog.formData.firstRentDate"
            type="date"
            placeholder="请选择首次收租日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同照片：">
          <el-upload
            action="/group1/upload?output=json"
            list-type="picture-card"
            :file-list="fileList"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            accept="image/gif,image/jpeg,image/png,.gif,.jpeg,.jpg,.png">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="姓名：" prop="name">
          <el-input placeholder="请输入姓名" v-model="rentRecordDialog.formData.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="idCard">
          <el-input placeholder="请输入身份证号" v-model="rentRecordDialog.formData.idCard"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input placeholder="请输入手机号" v-model="rentRecordDialog.formData.phone"></el-input>
        </el-form-item>
        <el-form-item label="工作单位：">
          <el-input placeholder="请输入工作单位" v-model="rentRecordDialog.formData.workPlace"></el-input>
        </el-form-item>
        <el-form-item label="人数：">
          <el-input-number v-model="rentRecordDialog.formData.personTotal" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="床：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.bed" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="桌子：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.board" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="椅子：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.chair" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="沙发：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.sofa" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="衣柜：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.wardrobe" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="冰箱：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.refrigerator" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="洗衣机：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.washingMachine" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="油烟机：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.hood" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="电磁炉：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.microwaveOven" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="燃气灶：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.gasCooker" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="热水器：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.heater" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="空调：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.airConditioning" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="钥匙：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.key" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input type="textarea" :rows="3" placeholder="请输入备注"
                    v-model="rentRecordDialog.formData.description"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-btn" v-if="showButton">
        <el-button @click="rentRecordDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="breakDialog.visible" :close-on-click-modal="false" width="30%" :title="rentRecordDialog.formData.state == 1 ? '正退' : '违退'">
      <el-form ref="breakForm" label-position="right" label-width="120px" :model="rentRecordDialog.formData"
               :rules="breakRules">
        <el-form-item :label="rentRecordDialog.formData.state == 1 ? '退款押金' : '违约金'" prop="breakRent">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%"
                           v-model="rentRecordDialog.formData.breakRent"
                           clearable/>
        </el-form-item>
        <el-form-item v-if="rentRecordDialog.formData.state == 2" label="退款房租" prop="backRent">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%"
                           v-model="rentRecordDialog.formData.backRent"
                           clearable/>
        </el-form-item>
        <el-form-item label="退租日期：" prop="breakDate">
          <el-date-picker
            v-model="rentRecordDialog.formData.breakDate"
            type="date"
            placeholder="请选择退租日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注：" prop="breakDescription">
          <el-input type="textarea" :rows="3" placeholder="请输入备注"
                    v-model="rentRecordDialog.formData.breakDescription"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="breakDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="breakData" :loading="breakLoading">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="contractDialog.visible" :close-on-click-modal="false" width="850px" title="">
      <div class="contract-main" id="contract">
        <div class="contract-main-content">
          <div class="title1">
            房 屋 租 赁 合 同
          </div>
          <div class="row">
            甲方（ 出租方） 姓名:
            <el-input class="flex-1" v-model="contractDialog.formData.partyAName" style="font-weight: bolder;"></el-input>
            电 话:
            <el-input class="flex-1" v-model="contractDialog.formData.partyAPhone"></el-input>
          </div>
          <div class="row">
            身份证号码:
            <el-input class="flex-1" v-model="contractDialog.formData.partyACard"></el-input>
          </div>
          <div class="row">
            乙方（ 承租方） 姓名:
            <el-input class="flex-1" v-model="contractDialog.formData.partyBName"></el-input>
            电 话:
            <el-input class="flex-1" v-model="contractDialog.formData.partyBPhone"></el-input>
          </div>
          <div class="row">
            身份证号码:
            <el-input class="flex-1" v-model="contractDialog.formData.partyBCard"></el-input>
            工作单位:
            <el-input class="flex-1" v-model="contractDialog.formData.partyBWork"></el-input>
          </div>
          <div class="row">
            经甲、乙双方在自愿、平等互利的基础上友好协商达成如下协议：
          </div>
          <div class="row">
            一、甲方将
            <el-input v-model="contractDialog.formData.address" style="width: 260px;"></el-input>
            的房屋出租乙方只能居住， 不得进行其它用途， 乙方共住
            <el-input v-model="contractDialog.formData.personTotal" style="width: 60px;"></el-input>
            人。
          </div>
          <div class="row">
            二、每月租金为
            <el-input v-model="contractDialog.formData.rent" style="width: 70px;"></el-input>
            元人民币，一次性共收押金
            <el-input v-model="contractDialog.formData.deposit" style="width: 70px;"></el-input>
            元人民币，每次交房租必须按照约定交租时间，先交钱后入住，
          </div>
          <div class="row">
            乙方租期不满退租视为违约，扣除当月房租和押金 。
          </div>
          <div class="row">
            三、从
            <el-input v-model="contractDialog.formData.fromYear" style="width: 70px;"></el-input>
            年
            <el-input max="12" v-model="contractDialog.formData.fromMonth" style="width: 70px;"></el-input>
            月
            <el-input v-model="contractDialog.formData.fromDay" style="width: 70px;"></el-input>
            日起至
            <el-input v-model="contractDialog.formData.toYear" style="width: 70px;"></el-input>
            年
            <el-input style="width: 70px;" v-model="contractDialog.formData.toMonth"></el-input>
            月
            <el-input style="width: 70px;" v-model="contractDialog.formData.toDay"></el-input>
            日， 租期期满前乙方不需
          </div>
          <div class="row">
            续签合同的，需提前壹个月通知甲方，甲方未接到通知的情况下，本合同作自动续签，续签时长为之前租期如原租期小于三个月的视为三个月，其余内容不变，此合同继续生效 。任何时间押金不可 以抵房租或其它费用。
          </div>
          <div class="row">
            四、租金
            <el-input v-model="contractDialog.formData.payMonth" style="width: 50px;"></el-input>
            个月支付一次， 以后每月付款时间为
            <el-input v-model="contractDialog.formData.payDate" style="width: 70px;"></el-input>
            号支付给甲方， 押金不可抵房租，逾期不付视为
          </div>
          <div class="row">
            违约处理，没收押金，甲方有权终止合同，乙方无条件退房。
          </div>
          <div class="row">
            五、乙方责任及义务： 为了您能有个舒适的环境 ， 请您及时打扫室内外 ，保持室内外的清 洁卫生 、保持通风换气 ， 节约水电 ， 并提高安全用电防火防盗意识。
          </div>
          <div class="row">
            六、乙方在居住期间 ， 不得以任何理由退房 ，转租需获得甲方同意 ，一旦主动退房，不但视为违约，没收当月房租 、押金外，还要交完已产生的一切费用，并要交 出钥匙方能搬出 。故意带走甲方租住房内的钥匙 家电 家具等物品的为盗窃 ， 情节严重报予警方处理。
          </div>
          <div class="row">
            七、乙方不得在室内打闹 ，喧哗 ， 电视音响太大 ，不得影响他人和邻居休息 ，一但发现视为违约扣除押金以及当月房租，并且无条件退房。
          </div>
          <div class="row">
            八、 乙方在入住期间 ，房租拖欠叁天 ，甲方联系不上乙方 ，视为乙方自愿放弃 ，甲方有权终止合同。 其室内物品，视作无主处理。入住天数不满壹个月，按壹个月计算。
          </div>
          <div class="row">
            九、如有故意损坏房内物品的，一切物品照价赔偿，将扣除房租、押金，收回房屋。
          </div>
          <div class="row">
            十、乙方保证遵守国家的法律法规规定以及租赁房屋所在小区的物业管理规约。乙方在居住期间的人身安全和财产安全由乙方自行负责，在租赁期内乙方是该房屋的实际管理人，该房屋内发生的所有安全事故都由乙方来承担与甲方无关包括但不限于高空抛物，水电使用不当，在房间内摔倒，给乙方及同住人造成的人生伤害等，甲方都不承担任何责任。
          </div>
          <div class="row"  style="display: -webkit-box;">
            十一、未经甲方允许，不得私自加人，加一人 多收房租壹佰 元/月，<span style="color: blue">未经房东批准不准养宠物，私养宠物按本合同第二条违约条款处理。</span>
          </div>
          <div class="row">
            十二、房间内物品如由人为损坏，按照物价赔偿，老旧自然损坏房东负责免费维修，如出现漏水（主要马桶），乙方没有及时通知甲方造成的损失由乙方承担，如由于乙方水电煤使用不当，导致出现火灾，漏水，漏电等情况出现意外，一切损失由乙方负责。乙方退租时如卫生没有打扫干净扣除200元押金。
          </div>
          <div class="row">
            十三、合同到期后，甲方如验房无误，会于10个工作日（自合同到期日起算）内退还乙方押金。乙方如需开具租房发票需签约前告知甲方。税点由乙方承担。
          </div>
          <div class="row">
            十四、房屋配置: 床
            <el-input v-model="contractDialog.formData.furniture.bed" style="width: 50px;"></el-input>
            只,桌子
            <el-input v-model="contractDialog.formData.furniture.board" style="width: 50px;"></el-input>
            张,椅子
            <el-input v-model="contractDialog.formData.furniture.chair" style="width: 50px;"></el-input>
            把,沙发
            <el-input v-model="contractDialog.formData.furniture.sofa" style="width: 50px;"></el-input>
            只,衣柜
            <el-input v-model="contractDialog.formData.furniture.wardrobe" style="width: 50px;"></el-input>
            个,冰箱
            <el-input v-model="contractDialog.formData.furniture.refrigerator" style="width: 50px;"></el-input>
            个,洗衣机
            <el-input v-model="contractDialog.formData.furniture.washingMachine" style="width: 50px;"></el-input>
            个,油烟机
            <el-input v-model="contractDialog.formData.furniture.hood" style="width: 50px;"></el-input>
            个,电磁炉
            <el-input v-model="contractDialog.formData.furniture.microwaveOven" style="width: 50px;"></el-input>
            个,燃气灶
            <el-input v-model="contractDialog.formData.furniture.gasCooker" style="width: 50px;"></el-input>
            个,热水器
            <el-input v-model="contractDialog.formData.furniture.heater" style="width: 50px;"></el-input>
            个,空调
            <el-input v-model="contractDialog.formData.furniture.airConditioning" style="width: 50px;"></el-input>
            台, 钥匙
            <el-input v-model="contractDialog.formData.furniture.key" style="width: 50px;"></el-input>
            把
          </div>
          <div class="row">
            备注：
            <el-input style="width: 100%;" v-model="contractDialog.formData.remark"></el-input>
          </div>
          <div class="row">
            十五、此合约为电子合约，以上协议内容甲乙双方一致同意，乙方在签字前已经对以上条约和约定仔细阅读并认可，签字生效，请妥善保存好自己的合同。
          </div>
          <div style="display: flex;justify-content: space-between;">
            <div class="row" style="display: flex;justify-content: space-between;" v-if="!contractDialog.formData.partyASignName || contractDialog.formData.partyASignName.indexOf('https://www.woyaozu.com.cn/group1') == -1">
              <div>
                甲方签名:
                <el-input v-model="contractDialog.formData.partyASignName"></el-input>
              </div>
            </div>
            <div class="row" v-if="contractDialog.formData.partyASignName && contractDialog.formData.partyASignName.indexOf('https://www.woyaozu.com.cn/group1') != -1">
              甲方签名:
            </div>
            <div class="row" style="display: flex;justify-content: center;align-items: center;" v-if="contractDialog.formData.partyASignName && contractDialog.formData.partyASignName.indexOf('https://www.woyaozu.com.cn/group1') != -1">
              <div v-if="contractDialog.formData.partyASignName">
                <img :src="contractDialog.formData.partyASignName" style="width: 35%;height: 35%;"/>
              </div>
            </div>
            <div class="row">
              乙方签名:
            </div>
            <div class="row" style="display: flex;justify-content: center;align-items: center;">
              <div v-if="contractDialog.formData.partyBSignName">
                <img :src="contractDialog.formData.partyBSignName" style="width: 35%;height: 35%;"/>
              </div>
            </div>
          </div>
          <div class="row" style="display: flex;justify-content: flex-end;">
            <div>
              签约日期：
              <el-input style="width: 70px;" v-model="contractDialog.formData.signYear"></el-input>
              年
              <el-input style="width: 70px;" v-model="contractDialog.formData.signMonth"></el-input>
              月
              <el-input style="width: 70px;" v-model="contractDialog.formData.signDay"></el-input>
              日
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-btn">
        <el-button @click="contractDialog.visible = false">取消</el-button>
<!--        <el-button type="primary" @click="saveContract(false)" :loading="contractLoading" v-if="showButton">保存</el-button>-->
<!--        <el-button type="primary" @click="createImg">生成合同</el-button>-->
        <el-button type="primary" @click="downloadContract" v-if="contractDialog.formData.contractUrl">下载</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="imageDialog.visible" :close-on-click-modal="false" width="30%"
               title="合同二维码">
      <img style="width: 300px;height: 300px;" :src="imageDialog.imageUrl">
      <div class="dialog-btn">
        <el-button @click="imageDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="downloadImage">下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList, deleteData, saveOrUpdateData, breakRecord, checkPrevious} from "@/api/rentRecord";
import {saveOrUpdateData as saveOrUpdateContract, getInfo} from "@/api/rentContract";
import {getQrCode} from "@/api/wechat";
import {uploadFile} from "@/api/fileUtil";
import html2canvas from 'html2canvas';
import JSPDF from 'jspdf';
import {getList as getAdmins} from "@/api/user";

export default {
  props: {
    rooms: {
      type: Array,
      default: () => []
    },
    roomId: {
      type: Number,
      default: 0
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: '',
          roomId: ''
        },
        total: 0,
        data: []
      },
      rentRecordDialog: {
        formData: {
          roomId: '',
          roomName: '',
          adminId: '',
          adminName: '',
          title: '',
          payType: 0,
          state: 0,
          deposit: 0,
          rent: 0,
          backRent: 0,
          startDate: '',
          endDate: '',
          firstRentDate: '',
          contractDate: '',
          description: '',
          breakDescription: '',
          breakDate: '',
          agencyFee: 0,
          workPlace: '',
          personTotal: 0,
          furniture: {
            bed: 1,
            board: 1,
            chair: 1,
            sofa: 1,
            teaTable: 1,
            wardrobe: 1,
            television: 1,
            setTopBox: 1,
            tvCabinet: 1,
            refrigerator: 1,
            washingMachine: 1,
            microwaveOven: 1,
            heater: 1,
            gasCooker: 1,
            hood: 1,
            airConditioning: 1,
            electricityMeterReading: 1,
            waterMterReading: 1,
            key: 1
          }
        },
        visible: false
      },
      rules: {
        roomId: [
          {trigger: 'change', required: true, message: '请选择房间'}
        ],
        adminId: [
          {trigger: 'change', required: true, message: '请选择管理员'}
        ],
        title: [
          {trigger: 'change', required: true, message: '请输入主题'}
        ],
        payType: [
          {trigger: 'blur', required: true, message: '请选择付款方式'}
        ],
        state: [
          {trigger: 'blur', required: true, message: '请选择状态'}
        ],
        deposit: [
          {trigger: 'blur', required: true, message: '请输入押金'}
        ],
        rent: [
          {trigger: 'blur', required: true, message: '请输入租金'}
        ],
        agencyFee: [
          {trigger: 'blur', required: true, message: '请输入支出中介费'}
        ],
        startDate: [
          {trigger: 'blur', required: true, message: '请选择开始日期'}
        ],
        endDate: [
          {trigger: 'blur', required: true, message: '请选择结束日期'}
        ],
        firstRentDate: [
          {trigger: 'blur', required: true, message: '请选择首次收租日期'}
        ],
        contractDate: [
          {trigger: 'blur', required: true, message: '请选择合同日期'}
        ]
      },
      breakDialog: {
        formData: {
          roomId: '',
          roomName: '',
          title: '',
          payType: 0,
          state: 0,
          deposit: 0,
          breakRent: 0,
          rent: 0,
          startDate: '',
          endDate: '',
          contractDate: '',
          imageUrls: '',
          firstRentDate: '',
          breakDescription: '',
          breakDate: '',
          name: '',
          idCard: '',
          phone: '',
          remark: ''
        },
        visible: false
      },
      breakRules: {
        breakRent: [
          {trigger: 'blur', required: true, message: '请输入金额'}
        ],
        breakDate: [
          {trigger: 'blur', required: true, message: '请选择退租日期'}
        ],
        backRent: [
          {trigger: 'blur', required: true, message: '请输入退款房租'}
        ]
      },
      loading: false,
      breakLoading: false,
      tableLoading: false,
      isEdit: false,
      payTypes: [
        {
          id: 0,
          name: '月付'
        },
        {
          id: 4,
          name: '两月付'
        },
        {
          id: 1,
          name: '季付'
        },
        {
          id: 2,
          name: '半年付'
        },
        {
          id: 3,
          name: '年付'
        }
      ],
      states: [
        {
          id: 0,
          name: '出租中'
        },
        {
          id: 4,
          name: '未生效'
        }
      ],
      oldPayType: 0,
      contractDialog: {
        formData: {
          code: '',
          rentRecordId: '',
          partyAName: '',
          partyAPhone: '',
          partyACard: '',
          partyBName: '',
          partyBPhone: '',
          partyBCard: '',
          partyBWork: '',
          address: '',
          personTotal: '',
          rent: '',
          deposit: '',
          startDate: '',
          endDate: '',
          payMonth: '',
          payDate: '',
          furniture: {
            bed: '',
            board: '',
            chair: '',
            sofa: '',
            teaTable: '',
            wardrobe: '',
            television: '',
            setTopBox: '',
            tvCabinet: '',
            refrigerator: '',
            washingMachine: '',
            microwaveOven: '',
            heater: '',
            gasCooker: '',
            hood: '',
            airConditioning: '',
            electricityMeterReading: '',
            waterMterReading: '',
            key: ''
          },
          remark: '',
          contractUrl: '',
          partyASignName: '',
          partyBSignName: '',
          fromYear: '',
          fromMonth: '',
          fromDay: '',
          toYear: '',
          toMonth: '',
          toDay: '',
          signYear: '',
          signMonth: '',
          signDay: '',
          stayPlace: '',
          generate: false,
          signed: false
        },
        visible: false
      },
      contractLoading: false,
      admins: [],
      imageDialog: {
        imageUrl: '',
        visible: false
      },
      userInfo: {},
      fileList: []
    }
  },
  mounted() {
    if (this.roomId) {
      this.table.query.roomId = this.roomId
      this.rentRecordDialog.formData.roomId = this.roomId
    }
    this.search(true)
    this.getAdmins()
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
  methods: {
    toDetail(row) {
      this.$router.push('/rentRecordDetail?roomId=' + row.roomId + '&rentRecordId=' + row.id)
    },
    getAdmins() {
      const params = {
        roleId: '2,5'
      }
      getAdmins(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.admins = response.data
        }
      })
    },
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        roomId: this.table.query.roomId,
        fromCooperateManage: !this.showButton
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改出租记录
    saveOrUpdateData() {
      this.loading = true
      this.$refs['rentRecordForm'].validate(async (valid) => {
        if (valid) {
          this.rentRecordDialog.formData.roomName = this.rooms.filter(item => item.id == this.rentRecordDialog.formData.roomId)[0].name
          this.rentRecordDialog.formData.adminName = this.admins.filter(item => item.id == this.rentRecordDialog.formData.adminId)[0].nickname
          this.rentRecordDialog.formData.fromPc = true
          const furniture = this.rentRecordDialog.formData.furniture
          if (furniture) {
            this.rentRecordDialog.formData.furniture = JSON.stringify(furniture)
          }
          if (this.rentRecordDialog.formData.idCard && this.rentRecordDialog.formData.name && this.rentRecordDialog.formData.phone) {
            this.rentRecordDialog.formData.state = 4
          } else {
            this.rentRecordDialog.formData.state = 0
          }
          saveOrUpdateData(this.rentRecordDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.rentRecordDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      console.log(isEdit)
      if (!isEdit) {
        // 校验上一个合同
        checkPrevious(this.roomId).then(response => {
          if (response.code == 200 && response.data) {
            // 重置数据
            this.rentRecordDialog.formData = {
              roomId: this.roomId,
              roomName: '',
              title: '',
              payType: 0,
              state: 0,
              deposit: 0,
              rent: 0,
              startDate: '',
              endDate: '',
              firstRentDate: '',
              contractDate: '',
              imageUrls: '',
              description: '',
              agencyFee: 0,
              name: '',
              idCard: '',
              phone: '',
              workPlace: '',
              personTotal: 0,
              stayPlace: '',
              furniture: {
                bed: 1,
                board: 1,
                chair: 1,
                sofa: 1,
                teaTable: 1,
                wardrobe: 1,
                television: 1,
                setTopBox: 1,
                tvCabinet: 1,
                refrigerator: 1,
                washingMachine: 1,
                microwaveOven: 1,
                heater: 1,
                gasCooker: 1,
                hood: 1,
                airConditioning: 1,
                electricityMeterReading: 1,
                waterMterReading: 1,
                key: 1
              }
            }
            if (this.roomId) {
              this.rentRecordDialog.formData.roomId = this.roomId
              this.oldPayType = this.rentRecordDialog.formData.payType
            }
            this.rentRecordDialog.visible = true
            // 清空验证信息
            this.$nextTick(() => {
              this.$refs.rentRecordForm.clearValidate()
            })
          } else {
            this.$message.error('新增失败，上一合同尚未结束!')
          }
        })
      } else {
        this.rentRecordDialog.formData = JSON.parse(JSON.stringify(data))
        if (this.rentRecordDialog.formData.furniture) {
          this.rentRecordDialog.formData.furniture = JSON.parse(this.rentRecordDialog.formData.furniture)
        } else {
          this.rentRecordDialog.formData.furniture = {}
        }
        this.rentRecordDialog.visible = true
        // 清空验证信息
        this.$nextTick(() => {
          this.$refs.rentRecordForm.clearValidate()
        })
      }
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除出租记录
    deleteData(id) {
      this.$confirm('此操作将永久删除出租记录信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    changePayType() {
      if (!this.rentRecordDialog.id) {
        this.$confirm('修改支付方式，保存后将重置收租记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

        }).catch(() => {
          this.rentRecordDialog.formData.payType = this.oldPayType
        })
      }
    },
    // 打开违退弹窗
    openBreakDialog(data, state) {
      this.rentRecordDialog.formData = JSON.parse(JSON.stringify(data))
      this.rentRecordDialog.formData.state = state;
      this.breakDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.breakForm.clearValidate()
      })
    },
    // 违退
    breakData() {
      if (this.rentRecordDialog.formData.breakDate < this.rentRecordDialog.formData.startDate) {
        this.$message.error('违约时间需大于开始时间')
        return;
      }
      this.breakLoading = true
      this.$refs['breakForm'].validate(async (valid) => {
        if (valid) {
          breakRecord(this.rentRecordDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.breakDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.breakLoading = false
          })
        } else {
          this.breakLoading = false
        }
      })
    },
    // 根据不同的年月日拼装日期格式
    dealDateFormat(year, month, day) {
      return `${year}-${month}-${day}`
    },
    saveContract(generate) {
      this.contractLoading = true;
      this.contractDialog.formData.generate = generate
      const furniture = this.contractDialog.formData.furniture
      if (furniture) {
        this.contractDialog.formData.furniture = JSON.stringify(furniture)
      }
      this.contractDialog.formData.rentRecordId = this.rentRecordDialog.formData.id
      this.contractDialog.formData.roomId = this.rentRecordDialog.formData.roomId
      this.contractDialog.formData.roomName = this.rentRecordDialog.formData.roomName
      this.contractDialog.formData.adminId = this.userInfo.id
      this.contractDialog.formData.adminName = this.userInfo.nickname
      // 拼接日期
      if (this.contractDialog.formData.fromYear && this.contractDialog.formData.fromMonth && this.contractDialog.formData.fromDay) {
        this.contractDialog.formData.startDate = this.dealDateFormat(this.contractDialog.formData.fromYear, this.contractDialog.formData.fromMonth, this.contractDialog.formData.fromDay)
      }
      if (this.contractDialog.formData.toYear && this.contractDialog.formData.toMonth && this.contractDialog.formData.toDay) {
        this.contractDialog.formData.endDate = this.dealDateFormat(this.contractDialog.formData.toYear, this.contractDialog.formData.toMonth, this.contractDialog.formData.toDay)
      }
      if (this.contractDialog.formData.signYear && this.contractDialog.formData.signMonth && this.contractDialog.formData.signDay) {
        this.contractDialog.formData.signDate = this.dealDateFormat(this.contractDialog.formData.signYear, this.contractDialog.formData.signMonth, this.contractDialog.formData.signDay)
      }
      // 拼装url
      saveOrUpdateContract(this.contractDialog.formData).then(response => {
        if (response.code == 200) {
          // 操作成功
          this.$message.success('操作成功!')
          this.contractDialog.visible = false
          this.search(false)
          if (generate && response.data.contractUrl) {
            window.open(response.data.contractUrl)
          }
          this.rentRecordDialog.formData = {
            roomId: this.roomId,
            roomName: '',
            adminId: '',
            adminName: '',
            title: '',
            payType: 0,
            state: 0,
            deposit: 0,
            rent: 0,
            startDate: '',
            endDate: '',
            firstRentDate: '',
            contractDate: '',
            description: '',
            breakDescription: '',
            breakDate: '',
            agencyFee: 0,
            workPlace: '',
            personTotal: 0,
            furniture: {
              bed: 1,
              board: 1,
              chair: 1,
              sofa: 1,
              teaTable: 1,
              wardrobe: 1,
              television: 1,
              setTopBox: 1,
              tvCabinet: 1,
              refrigerator: 1,
              washingMachine: 1,
              microwaveOven: 1,
              heater: 1,
              gasCooker: 1,
              hood: 1,
              airConditioning: 1,
              electricityMeterReading: 1,
              waterMterReading: 1,
              key: 1
            }
          }
          if (this.roomId) {
            this.rentRecordDialog.formData.roomId = this.roomId
            this.oldPayType = this.rentRecordDialog.formData.payType
          }
        } else {
          // 操作失败
          this.$message.error('操作失败!')
        }
        this.contractLoading = false
      })
    },
    downloadContract() {
      window.open(this.contractDialog.formData.contractUrl)
    },
    openContractDialog(row) {
      this.rentRecordDialog.formData = JSON.parse(JSON.stringify(row))
      getInfo(row.id).then(response => {
        this.contractDialog.formData = response.data
        const furniture = response.data.furniture || "{}"
        if (furniture) {
          this.contractDialog.formData.furniture = JSON.parse(furniture || "{}")
        }
        // 处理时间
        const startDate = this.contractDialog.formData.startDate
        if (startDate) {
          const dates = startDate.split('-');
          this.contractDialog.formData.fromYear = parseInt(dates[0])
          this.contractDialog.formData.fromMonth = parseInt(dates[1])
          this.contractDialog.formData.fromDay = parseInt(dates[2])
        } else {
          this.$set(this.contractDialog.formData, 'fromYear', '')
          this.$set(this.contractDialog.formData, 'fromMonth', '')
          this.$set(this.contractDialog.formData, 'fromDay', '')
        }
        const endDate = this.contractDialog.formData.endDate
        if (endDate) {
          const dates = endDate.split('-');
          this.contractDialog.formData.toYear = parseInt(dates[0])
          this.contractDialog.formData.toMonth = parseInt(dates[1])
          this.contractDialog.formData.toDay = parseInt(dates[2])
        } else {
          this.$set(this.contractDialog.formData, 'toYear', '')
          this.$set(this.contractDialog.formData, 'toMonth', '')
          this.$set(this.contractDialog.formData, 'toDay', '')
        }
        const signDate = this.contractDialog.formData.signDate
        if (signDate) {
          const dates = signDate.split('-');
          this.contractDialog.formData.signYear = parseInt(dates[0])
          this.contractDialog.formData.signMonth = parseInt(dates[1])
          this.contractDialog.formData.signDay = parseInt(dates[2])
        } else {
          this.$set(this.contractDialog.formData, 'signYear', '')
          this.$set(this.contractDialog.formData, 'signMonth', '')
          this.$set(this.contractDialog.formData, 'signDay', '')
        }
        this.contractDialog.visible = true
      })
    },
    // 展示二维码
    openImage(id) {
      getQrCode(id).then(response => {
        if (response.code == 200) {
          this.imageDialog.imageUrl = response.data
          this.imageDialog.visible = true
        }
      });
    },
    // 下载二维码
    downloadImage() {
      window.open(this.imageDialog.imageUrl)
    },
    createImg() {
      let _this = this
      //解决页面带滚动条的时候截图不全问题
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      let canvas = document.createElement('canvas')
      let context = canvas.getContext('2d')
      //需要转换的html元素
      let _articleHtml = document.getElementById('contract')
      let _w = _articleHtml.clientWidth
      let _h = _articleHtml.clientHeight
      debugger
      //解决生成的pdf不清晰的问题 先放大4倍----后面再缩小4倍
      let scale = 2
      canvas.width = _w * scale
      canvas.height = _h * scale
      context.scale(scale, scale)
      let opts = {
        scale: 1,
        width: _w,
        height: _h,
        canvas: canvas,
        useCORS: true
      };
      (window.html2canvas || html2canvas)(_articleHtml, opts).then(canvas => {
        _this.createPdf(canvas, scale)
      })
    },
    createPdf(canvas, scale) {
      //图片->pdf
      //-----------宽高缩小4倍---------------------
      let contentWidth = canvas.width / scale
      let contentHeight = canvas.height / scale
      //--------------------
      let orientation = 'p'
      // 在 jspdf 源码里，如果是 orientation = 'p' 且 width > height 时， 会把 width 和height 值交换，
      // 类似于 把 orientation 的值修改为 'l' , 反之亦同。
      if (contentWidth > contentHeight) {
        orientation = 'l'
      }

      let pdf = new JSPDF(orientation, 'pt', [contentWidth, contentHeight])
      let pageData = canvas.toDataURL('image/jpeg', 1.0)

      //这里只生成了一页的pdf，并未截断，需要截断的话在此处操作
      pdf.addImage(pageData, 'JPEG', 0, 0, contentWidth, contentHeight)

      //将pdf的流文件---》file文件
      let filename = this.contractDialog.formData.partyBName + '_' + this.contractDialog.formData.address + '.pdf'
      let datauri = pdf.output('dataurlstring')
      let file = this.dataURLtoFile(datauri, filename)

      this.uploadPDF(file)
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      //转换成file对象
      return new File([u8arr], filename, { type: mime })
      //转换成成blob对象
      //return new Blob([u8arr],{type:mime});
    },
    uploadPDF(file){
      // 以文件的形式上传给服务器
      const formData = new FormData()
      formData.append('file', file)
      uploadFile(formData).then(response => {
        this.contractDialog.formData.contractUrl = response.path
        this.saveContract(true)
      })
    },
    handleSuccess(response, file) {
      this.fileList.push({
        uid: file.uid,
        url: response.url
      })
      this.rentRecordDialog.formData.imageUrls = this.fileList.map(item => item.url).join(',')
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => item.url != file.url)
      if (this.fileList && this.fileList.length > 0) {
        this.rentRecordDialog.formData.imageUrls = this.fileList.map(item => item.url).join(',')
      } else {
        this.rentRecordDialog.formData.imageUrls = ''
      }
    },
  }
}
</script>

<style scoped lang="scss">
.contract-main {
  margin: 0 auto;
  width: 770px;
  padding: 15px;
  .flex-1 {
    flex: 1;
  }

  &-content {
    text-align: left;
    width: 100%;
    /deep/ .el-input {
      width: 150px;

      input {
        border: none;
        border-bottom: 1px solid #DCDFE6;
        border-radius: 0;
        height: 25px !important;
        line-height: 20px !important;
        font-weight: bolder;
        color: blue;
      }
    }

    .title1 {
      text-align: center;
      font-size: 20px;
      width: 100%;
    }

    .no {
      text-align: right;
      font-size: 18px;
      width: 100%;

      .noTxt {
        font-weight: bold;
      }

      .noNumber {
        color: red;
      }
    }

    .row {
      width: 100%;
      display: flex;
      align-items: baseline;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-bottom: 10px;
      line-height: 2;
      font-weight: bold;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/RentRecord.vue